<template>
  <div class="base-div header-with-button pa-4">
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex align-center">
        <BaseButton
          type-button="tertiary"
          svg-icon-name="back"
          @click="goBack"
        />
        <p class="mb-0 subtitle-1 black--text">{{ title }}</p>
      </div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PageHeader extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ default: "timelineHome" }) fallbackRoute!: string;

  goBack(): void {
    if (this.$listeners && (this.$listeners as Record<string, unknown>).back) {
      this.$emit("back");
      return;
    }
    const stack: Array<{
      name: string;
      params?: Record<string, any>;
      query?: Record<string, any>;
    }> = (this.$store.state as any).navigationStack;
    if (stack.length > 0) {
      const previousRoute = stack[stack.length - 1];
      this.$store.commit("setGoingBack", true);
      this.$store.commit("popNavigation");
      if (previousRoute.name === this.$route.name) {
        this.$router
          .replace({
            name: previousRoute.name,
            params: previousRoute.params,
            query: previousRoute.query,
          })
          .catch((_e) => _e);
      } else {
        this.$router.back();
      }
    } else {
      this.$router.push({ name: this.fallbackRoute }).catch((_e) => _e);
    }
  }
}
</script>
